// extracted by mini-css-extract-plugin
export default {"checkboxContainer":"Checkbox_checkboxContainer__i+ACq","checkboxLabel":"Checkbox_checkboxLabel__k4+s1","checkboxInput":"Checkbox_checkboxInput__GE8sW"};